import { IReporteCompraParams, IReporteCompraResp } from "@/erp/compras/reporte-compra/types/reporte-compra.interface";
import { erpApi } from "@/shared/axios";
import { urlBackend } from "@/shared/constants";
import { getUrlParamsFetch } from "@/shared/utils";
import {  useQuery } from "@tanstack/react-query";

const { get } = erpApi()

export const useGetFetchReporteCompra = (params?:IReporteCompraParams, /* enabled=true */) => {
  console.log(params);
  
  return useQuery({
    queryKey:['reporteCompra', ...Object.values(params ?? {})],
    queryFn: async ()=>{
      return await getReporteCompra(params)
    },
    refetchOnWindowFocus: false,
  })
}
export const getReporteCompra = (params?:IReporteCompraParams)=>{
  const queryParams = getUrlParamsFetch(params || {})  
  return get<IReporteCompraResp>(`${urlBackend}api/v1/ingreso-inventario/reporte-compra/?${queryParams}`, true)
}